import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import AppLayout from "./components/AppLayout";
import RouteTracker from "./components/RouteTracker";
import Landing from "./pages/Landing";
import Subscribe from "./pages/Subscribe";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AcceptInvite from "./pages/AcceptInvite";
import Onboarding from "./pages/Onboarding";
import Dashboard from "./pages/Dashboard";
import Opportunities from "./pages/Opportunities";
import OpportunityDetail from "./pages/OpportunityDetail";
import Tracked from "./pages/Tracked";
import Pipeline from "./pages/Pipeline";
import Funding from "./pages/Funding";
import PolicyRadar from "./pages/PolicyRadar";
import Alerts from "./pages/Alerts";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";
import Account from "./pages/Account";
import Billing from "./pages/Billing";
import Unstuck from "./pages/Unstuck";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <RouteTracker />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/accept-invite" element={<AcceptInvite />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/unstuck" element={<Unstuck />} />
          <Route path="/app" element={<AppLayout />}>
            <Route index element={<Navigate to="/app/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="opportunities" element={<Opportunities />} />
            <Route path="opportunities/:id" element={<OpportunityDetail />} />
            <Route path="pipeline" element={<Pipeline />} />
            <Route path="funding" element={<Funding />} />
            <Route path="radar" element={<PolicyRadar />} />
            <Route path="tracked" element={<Tracked />} />
            <Route path="alerts" element={<Alerts />} />
            <Route path="profile" element={<Profile />} />
            <Route path="settings" element={<Settings />} />
            <Route path="account" element={<Account />} />
            <Route path="billing" element={<Billing />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
